module.exports = __webpack_public_path__ + "img/lab-flask.7026ffb3.svg";